import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { formatRequest, prepareHeaders } from 'evolve-ui';

import { Request } from 'evolve-ui';

type TUnsubscribeCampaignData = {
  unsubscribeGroupId: number;
  email: string;
};

export const unsubscribeCampaignsApi = createApi({
  reducerPath: 'unsubscribeCampaigns',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.GATSBY_COMMUNICATION_BRIDGE_API_URL}/campaigns`,
    mode: 'cors',
    prepareHeaders,
  }),
  tagTypes: ['UnsubscribeCampaigns'],
  endpoints: (builder) => ({
    unsubscribeCampaign: builder.mutation<Response, TUnsubscribeCampaignData>({
      query: (params) => {
        return formatRequest(
          { ...params, type: 'unsubscribe-campaign' },
          Request.POST,
          '/unsubscribe'
        );
      },
    }),
  }),
});

export const { useUnsubscribeCampaignMutation } = unsubscribeCampaignsApi;
